import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';

import { _getCountry } from '@/api/lookup/queries';
import { TextCell } from '@/design-system';

import { EntityTabTableRow } from '../data';

export const EntitiesTabTableCountry: FC<Pick<EntityTabTableRow, 'country'>> = ({ country }) => {
  const { data } = useQuery(_getCountry(country || ''));
  return <TextCell title={data?.name ?? '-'} />;
};
